import { NgModule } from '@angular/core';
import {LoanPayoutDialogComponent} from '@client/shared/components/loan/loan-payout/loan-payout-dialog/loan-payout-dialog.component';
import { LoanPayoutFormComponent } from '@client/shared/components/loan/loan-payout/loan-payout-form/loan-payout-form.component';
import {SharedModule} from '@shared/shared.module';

@NgModule({
  declarations: [
    LoanPayoutDialogComponent,
    LoanPayoutFormComponent
  ],
  imports: [
    SharedModule,
  ],
  exports: [
    LoanPayoutDialogComponent,
    LoanPayoutFormComponent
  ],
})
export class LoanModule { }
